<template>
    <div class="d-flex all-after-header-box">
        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >
                <template v-if="allowReceptionSchedule && allowReceptionScheduleAdd">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </template>

                <v-list
                    nav
                    dense
                    shaped
                >
                    <v-list-item-group>
                        <template v-for="item in qalaQyzmetItems">
                            <v-list-item
                                link
                                v-if="$validatePermission(item.access)"
                                :key="item.route"
                                :to="{ name: item.route }"
                            >
                                <v-list-item-icon>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t(item.name) }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>

               
                <template>
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        shaped
                    >
                        <v-list-item-group>
                            <v-list-item
                                link
                                :to="{ name: 'QalaQyzmetInWork' }"
                            >
                                <v-list-item-icon>
                                <v-icon>far fa-cogs</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("В_работе") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </template>

                <template v-if="allowReceptionSchedule">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        shaped
                    >
                        <v-list-item-group>
                           <v-list-item
                                link
                                :to="{ name: 'ReceptionScheduleCalendar' }"
                            >
                                <v-list-item-icon>
                                <v-icon>far fa-calendar-alt</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Календарь_приема") }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                link
                                :to="{ name: 'ReceptionScheduleList' }"
                            >
                                <v-list-item-icon>
                                <v-icon>far fa-list-alt</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Список_приема") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </template>

            </v-navigation-drawer>
        </div>

        <div class="content-box">
            <div v-if="$route.name == 'QalaQyzmet'">
                {{$t("Городские_услуги")}}
            </div>
            <router-view v-else :key="$router.fullPath" />
            
        </div>

        <input
            type="file"
            style="display: none"
            ref="inputFileToCommentIQala"
            multiple
            @change="onInputFileToCommentIQalaChange"
        />

        <CSCRegistryDlg v-if="isCscRegistryVisible" />
        <CSCAnswerDlg v-if="isCscAnswerVisible" />
        <CSCCustomAnswerDlg v-if="isCscCustomAnswerVisible" />
        <CSCFormAnAnswerDlg v-if="isCscFormAnAnswerVisible" />
        <CSCFormAnAnswer060X0001Dlg v-if="isCscFormAnAnswer060X0001Visible" />
        <CSCRejectionDlg v-if="isCscRejectionVisible" />
        <CSCInvoiceDlg v-if="isCscInvoiceVisible" />
        <CSCCommentDlg v-if="isCscCommentVisible" />
        <CSCContractInfoDlg v-if="isCscContractInfoVisible" />
        <CSCConfirmReceptionDlg v-if="isCscConfirmReceptionVisible" />
        <CSCPrepareСonclusionDlg v-if="isCscPrepareСonclusionVisible" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "QalaQyzmetMain",
    components: {
        CSCRegistryDlg: () => import('@/components/qala-qyzmet/dialogs/CSCRegistryDlg'),
        CSCAnswerDlg: () => import('@/components/qala-qyzmet/dialogs/CSCAnswerDlg'),
        CSCCustomAnswerDlg: () => import('@/components/qala-qyzmet/dialogs/CSCCustomAnswerDlg'),
        CSCFormAnAnswerDlg: () => import('@/components/qala-qyzmet/dialogs/CSCFormAnAnswerDlg'),
        CSCFormAnAnswer060X0001Dlg: () => import('@/components/qala-qyzmet/dialogs/CSCFormAnAnswer060X0001Dlg'),
        CSCRejectionDlg: () => import('@/components/qala-qyzmet/dialogs/CSCRejectionDlg'),
        CSCInvoiceDlg: () => import('@/components/qala-qyzmet/dialogs/CSCInvoiceDlg'),
        CSCCommentDlg: () => import('@/components/qala-qyzmet/dialogs/CSCCommentDlg'),
        CSCContractInfoDlg: () => import('@/components/qala-qyzmet/dialogs/CSCContractInfoDlg'),
        CSCConfirmReceptionDlg: () => import('@/components/qala-qyzmet/dialogs/CSCConfirmReceptionDlg'),
        CSCPrepareСonclusionDlg: () => import('@/components/qala-qyzmet/dialogs/CSCPrepareConclusionDlg')
    },
    asyncComputed: { },
    computed: {
        ...mapGetters(
        {
            drawerLeftMenuMini: 'isDrawerLeftMenuMinimized'
        }),
        ...mapGetters('qalaQyzmet/dialogs/cscRegistry', { isCscRegistryVisible: 'getVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscAnswer', { isCscAnswerVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscCustomAnswer', { isCscCustomAnswerVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscFormAnAnswer', { isCscFormAnAnswerVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscFormAnAnswer060X0001', { isCscFormAnAnswer060X0001Visible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscRejection', { isCscRejectionVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscInvoice', { isCscInvoiceVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscComment', { isCscCommentVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscContractInfo', { isCscContractInfoVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscConfirmReception', { isCscConfirmReceptionVisible: 'isVisible' }),
        ...mapGetters('qalaQyzmet/dialogs/cscPrepareConclusion', { isCscPrepareСonclusionVisible: 'isVisible' }),
        allowReceptionSchedule(){
            return this.$store.getters['global/auth/getUserInfo'].Permissions.includes("ReceptionSchedule");
        },
        allowReceptionScheduleAdd(){
            return this.$store.getters['global/auth/getUserInfo'].Permissions.includes("ReceptionScheduleAdd");
        }
    },
    data: () => ({
        drawerLeftMenu: true,
        drawerLeftMenuHover: false,

        group1: {
            active: false
        },

        qalaQyzmetItems: [
            {
                name: "Заявки",
                route: "QalaQyzmetRequests",
                icon: "far fa-bullhorn",
                access: { permissions: [] }
            },
            {
                name: "Договоры",
                route: "QalaQyzmetContracts",
                icon: "far fa-file-signature",
                access: { permissions: [] }
            },
            {
                name: "Наряды",
                route: "QalaQyzmetTasks",
                icon: "far fa-clipboard-list",
                access: { permissions: [] }
            }
        ],
    }),
    methods: {
        ...mapActions('global/actionsource', ['loadDataSource']),
        ...mapActions('global/comments', ['onFileIQalaCommentPicked']),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;  
        },
        onInputFileToCommentIQalaChange(e) {
            this.onFileIQalaCommentPicked({ e, id: this.getCurrentDocumentId })
        },
        async onCreateClicked() {
            await this.loadDataSource({ createType: "None.Reception", navigate: true, common: false });
        },
    },
    mounted() {
        this.$eventBus.$on('on-input-file-to-comment-iqala', async /*id*/() => {
            this.$refs.inputFileToCommentIQala.click();
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('on-input-file-to-comment-iqala');
    }
}
</script>